import React from 'react';
import EmptyState from '@atlaskit/empty-state';
import { useIntl } from '@atlassian/jira-intl';
import cloud from './assets/cloud.svg';
import messages from './messages';

const NoAttachments = () => {
	const { formatMessage } = useIntl();
	return (
		<EmptyState
			imageUrl={cloud}
			header={formatMessage(messages.emptyStateTitle)}
			description={formatMessage(messages.emptyStateDescription)}
		/>
	);
};

export default NoAttachments;
